"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CellAttachment = void 0;
const core_1 = require("@apitable/core");
const react_1 = __importDefault(require("react"));
const styled_1 = require("./styled");
const file_type_1 = require("./utils/file_type");
const components_1 = require("@apitable/components");
const HEIGHT = 24;
function calcFileWidth(file, ratioHeight) {
    if (!(file.width && file.height)) {
        return 'auto';
    }
    if (!(0, file_type_1.showOriginImageThumbnail)(file)) {
        return 'auto';
    }
    const ratio = file.width / file.height;
    return ratioHeight * ratio;
}
const CellAttachment = (props) => {
    const { files, className, style, cellClassName, cellStyle } = props;
    if (!files) {
        return null;
    }
    return (react_1.default.createElement(styled_1.AttachmentWrapperStyled, { className: className, style: style }, files.map((file, index) => {
        const imgUrl = (0, file_type_1.getCellValueThumbSrc)(file, {
            h: HEIGHT,
            formatToJPG: (0, core_1.isGif)({ name: file.name, type: file.mimeType }),
        });
        return (react_1.default.createElement(components_1.Tooltip, { content: file.name, key: file.id + index },
            react_1.default.createElement(styled_1.AttachmentDiv, { className: cellClassName, style: cellStyle },
                react_1.default.createElement("img", { src: imgUrl, width: calcFileWidth(file, HEIGHT), height: HEIGHT }))));
    })));
};
exports.CellAttachment = CellAttachment;
